import React from "react"
import { useParams } from "react-router-dom"

import { Box, FlexRow } from "components/box"
import { Col } from "components/grid"
import { MainContainer } from "components/main-container"
import { SectionTitle } from "components/page-elements"

const CareersFull = () => {
  const { greenhouseId } = useParams<{ greenhouseId: string }>()
  return (
    <MainContainer
      my={[2, 2, 6, 6]}
      mainContent={
        <FlexRow justifyContent={"center"}>
          <Col cols={[4, 3, 8, 6]}>
            <SectionTitle
              title="Open Positions"
              description="Thirty Madison is rebuilding the healthcare experience for the modern consumer."
            />
            <Box my={6}>
              <iframe
                id="grnhse_iframe"
                width="100%"
                scrolling="no"
                allow="geolocation"
                title="Greenhouse Job Board"
                frameBorder="0"
                src={`https://boards.greenhouse.io/embed/job_app?for=thirtymadison&amp;token=${greenhouseId}`}
                height="4332"
              ></iframe>
            </Box>
          </Col>
        </FlexRow>
      }
    />
  )
}

export default CareersFull
